import MailingHome from '@/pages/mailing/MailingHome'

const routes = [
  {
    path: '/mailing',
    name: 'MailingHome',
    component: MailingHome,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/mailing.js